module.exports = __webpack_public_path__ + "html/block-wrapper.component.html";